<ish-error-message [error]="loginError$ | async" [toast]="false" />

<form [formGroup]="form" ishFormSubmit #loginForm="ngForm" class="form-horizontal" (ngSubmit)="loginUser()" novalidate>
  <formly-form [form]="form" [fields]="fields" />

  <div class="row form-group align-items-center forgot-msg">
    <div [ngClass]="signInClass() || 'col-sm-4  col-md-3'">
      <button
        type="submit"
        value="Login"
        name="login"
        class="btn btn-primary"
        [disabled]="form.invalid && loginForm.submitted"
      >
        {{ 'account.signin.button.label' | translate }}
      </button>
    </div>

    <div [ngClass]="forgotPasswordClass() || 'col-sm-8 col-md-9 pl-md-0'">
      <a class="btn btn-link" [routerLink]="'/forgotPassword'">{{ 'account.send_password.heading' | translate }}</a>
    </div>
  </div>
</form>
